import defineComponent from 'flight';
import $ from 'static/script/libs/jquery';
import cookieUtil from 'static/script/utils/cookie';

function SignupReferralPathCookieCreator () {
    let cookieName = 'signup_referral_path';

    let setCookie = function (value) {
        let expireDate = new Date();
        expireDate.setTime(expireDate.getTime()  + (10 * 60 * 1000));
        cookieUtil.createCookie(cookieName, value, expireDate);
    };

    this.createSignupReferralPathCookie = function () {
        let referralPath = window.location.href;
        setCookie(referralPath);
    };

    this.after('initialize', function () {
        this.on('click', this.createSignupReferralPathCookie);
    });
}

module.exports = defineComponent.component(SignupReferralPathCookieCreator);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/layout/signup-referral-path-cookie-creator.js